module.exports = __webpack_public_path__ + "img/lxwmImg.e7164afb.png";